import { render, staticRenderFns } from "./MoveToFolderModal.vue?vue&type=template&id=05df3a9a&scoped=true&"
import script from "./MoveToFolderModal.vue?vue&type=script&lang=js&"
export * from "./MoveToFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveToFolderModal.vue?vue&type=style&index=0&id=05df3a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df3a9a",
  null
  
)

export default component.exports